import Login from './pages/Login';
import { LoginProps } from '../Login/LoginForm';
import PrivateApp from 'Pages/App/PrivateApp';
import { RedirectToLogin } from 'Components';

export default function NewLogin({ firstTimeSignIn }: LoginProps) {
	const checktenanturl = window.location.href;
	const isAdmin = checktenanturl.includes('.io/logi');

	return (
		<PrivateApp>
			{(isAuthenticated) =>
				isAuthenticated ? (
					<RedirectToLogin />
				) : (
					<Login isAdminLogin={isAdmin} />
				)
			}
		</PrivateApp>
	);
}
